export default {"src":"/_next/static/media/stethoscope.d54c8d89.svg","height":206,"width":234,"blurWidth":0,"blurHeight":0};